import React from 'react';

const ReportRecapForecastCell = ({ value, row }) => {
  if (value < row.original.idealNumContractDays)
    return <div className="font-red">{parseFloat(value).toFixed(2)}</div>;
  return <div>{parseFloat(value).toFixed(2)}</div>;
};

export default ReportRecapForecastCell;
